import {useQuery} from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";
import {sortCountries} from "../utils/countriesHelpers";

export const useGetNationalities = () => {
    const {
        isFetching: isLoading, data: nationalities, error,
    } = useQuery({
        queryKey: ["nationalities"],
        queryFn: () => axiosManager.get$("nationalities").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const nationalitiesOptions = sortCountries((nationalities || []).map((item) => ({value: item.countryCode, label: item.name})));

    return {
        isLoading, nationalities, error, nationalitiesOptions,
    };

};
